// India state names — used by CheckoutPage for the state dropdown.
//
// The earlier version of this file shipped a full state → city → pincode
// tree (~300 lines) along with helpers for cascading city/pincode lookups.
// Nothing consumed those helpers, so the data has been removed. Add city
// and pincode lookups back here only if a checkout cascade actually needs
// them; otherwise the smaller bundle is preferable.

const STATE_NAMES: readonly string[] = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  // Union Territories
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Jammu and Kashmir',
  'Ladakh',
  'Lakshadweep',
  'Puducherry',
];

export function getStateNames(): string[] {
  return [...STATE_NAMES];
}
